export default theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2)
  },

  fieldError: {
    color: theme.palette.danger.main,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1)
  },
  utteranceItem: {
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#fff",
    padding: 5,
    border: "1px solid #eef0f5",
    width: "auto",
    borderRadius: 5,
    boxShadow: "0 1px 1px rgba(0,0,0,0.1)"
  },
  formGroup: {
    alignItems: "center",
    minWidth: 125,
    marginLeft: 10
  },
  utteranceIcons: {
    marginLeft: -25,
    marginRight: 20
  },
  clusterGroup: {
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: `${theme.palette.background.light}`,
    position: "sticky",
    top: 80,
    boxShadow: "0 6px 5px -3px #e6e7ef, 0 2px 2px -2px #4f526b",
    zIndex: 2,
    paddingTop: 4,
    paddingBottom: 4,
    borderRight: `3px solid ${theme.palette.background.light}`
  },
  utteranceList: {
    padding: "4px 4px 7px 4px"
  },
  utteranceButton: {
    marginLeft: "auto!important"
  },
  listItemInner: {
    display: "flex",
    justifyContent: "space-between",
    padding: "4px 7px 0 8px"
  },
  utteranceListSpecial: {
    minHeight: "40vh",
    maxHeight: "55vh",
    overflow: "auto",
    padding: "4px"
  },
  clusterGroupText: {
    display: "flex",
    width: "80%"
  },
  singleIcon: {
    margin: "10px"
  },
  disabledCheckbox: {
    opacity: ".5"
  },
  selectedCheckbox: {
    opacity: 1
  },
  clustersPlaceholder: {
    position: "sticky",
    top: "80px",
    minWidth: "49%",
    marginLeft: "10px",
    flexGrow: 1,
    alignSelf: "flex-start",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.light,
    paddingBottom: 4
  },
  clusterHolder: {
    flexGrow: "1",
    minWidth: "49%",
    marginBottom: "50vh"
  },
  clusterTitle: {
    opacity: ".8",
    color: theme.palette.primary.main,
    maxWidth: "75%",
    overflow: "hidden"
  },
  cluster: {
    marginBottom: "10px",
    backgroundColor: theme.palette.background.light,
    boxShadow: "0 2px 2px -1px rgba(0,0,0,0.1)"
  },
  activeClusterGroup: {
    borderLeft: `3px solid ${theme.palette.success.light}`
  },
  activeCluster: {
    "& > li:first-of-type": {
      borderRight: `3px solid ${theme.palette.success.light}`
    }
  },
  modalTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "5px 5px 5px 20px"
  },
  mainClusterButton: {
    width: "fit-content",
    marginBottom: -55,
    marginTop: 30
  },
  groupLabel: {
    color: theme.palette.text.disabled,
    fontWeight: 400
  },
  modalTitleLight: {
    color: theme.palette.text.light
  },
  clusterConnector:{
    color: theme.palette.text.light,
    fontWeight: 400,
    marginLeft: 5
  },
  resultCount: {
    color: theme.palette.text.disabled,
    fontSize: 14,
    marginTop: 3,
    display: "inline-block" }
});
